/**
 * TORNARE INDIETRO SENZA IL TASTO DEL BROWSER (06/10/2026).
 *
 * Davide: «non ci sono tasti per tornare indietro su schermo, e con il banco
 * che ha solo il touchscreen non saprei proprio come fare». Tre posti dove il
 * tasto del browser non c'e': il chiosco Linux (Chromium a tutto schermo,
 * niente barra, niente tastiera), l'app sull'iPhone (nessun tasto di sistema),
 * e chi apre una pagina da un link. Ogni pagina fuori dal menu deve avere il
 * SUO tasto per uscire, sullo schermo.
 *
 * «Indietro» deve fare la cosa giusta anche quando una pagina prima non c'e':
 * il chiosco riapre Chromium sulla chat dopo tre minuti fermo, un link di una
 * mail apre una pagina nuova, l'app parte da una notifica. Li' history.back()
 * non fa niente (o esce dall'app): si va invece a una pagina «madre» sicura.
 *
 * COME SI SA SE C'E' UNA PAGINA PRIMA. React Router scrive in history.state un
 * contatore `idx`: 0 per la prima pagina aperta nella scheda, +1 a ogni
 * navigazione, uguale a ogni sostituzione (i rimandi dopo l'accesso). Quindi
 * idx > 0 = c'e' una pagina dell'app prima di questa. `window.history.length`
 * invece conta anche le pagine di altri siti e quelle «avanti»: non serve.
 */
export function cePaginaPrima(stato: unknown = typeof window !== "undefined" ? window.history.state : null): boolean {
  const idx = (stato as { idx?: unknown } | null)?.idx;
  return typeof idx === "number" && idx > 0;
}
